
import {
  useContext,
  createContext,
  useState,
  useEffect,
  useRef,
  useMemo,
} from "react";


export const MeetingAppContext = createContext();

export const useMeetingAppContext = () => useContext(MeetingAppContext);


export const MeetingAppProvider = ({ children }) => {
  const timesChatOpened = {count: 0};

  const [raisedHandsParticipants, setRaisedHandsParticipants] = useState([]);
  const [sideBarMode, setSideBarMode] = useState(null); 
   const [draftPolls, setDraftPolls] = useState([]);
  const [createdPolls, setCreatedPolls] = useState([]);
  const [endedPolls, setEndedPolls] = useState([]);
    const ws = useRef(null);
    const [WebSocketMessages, setMessages] = useState([]);
    const [whiteBoardActive, setWhiteBoardActive] = useState(false);
    const [whiteBoardOpenedBy, setWhiteBoardOpenedBy] = useState("");
    const [whiteboardUrlStored, setWhiteBoardUrlStored] = useState(null);
    const [isWebsocketConnected, setIsConnected] = useState(false);
  const [networkStrengthOfParticipants , setNetworkStrengthOfParticipants] = useState()

  const [afterMeetingJoinedHLSState, setAfterMeetingJoinedHLSState] =
    useState(null);
const [raisedHandcountContext , setRaisedHandcountcontext] = useState(0)
  const [pollId, setPollId] = useState();
  const [openStudentPollModal, setOpenStudentPollModal] = useState(false);
  const [allPollDetails, setAllPollDetails] = useState(null);
  const [currentPollDuration, setCurrentPollDuration] = useState(0);
  const timerRef = useRef(null);
  const [openPollModal, setOpenPollModal] = useState(false);
  const [unReadCount, setUnreadCount] = useState(0)
  const [openReport, setOpenReport] = useState(false);
  const [meetingRecord, setMeetingRecord] = useState({});
  const [isClassOver, setIsClassOver] = useState()
  // const { isSession } = useSel/ector(state => state.login);
  const [isWhiteBoardOpen , setIsWhiteBoardOpen] = useState(false)
  const [isFullscreenModalOpen, setIsFullscreenModalOpen] = useState(false);


  const polls = useMemo(
    () =>
      createdPolls.map((poll) => ({
        ...poll,
        isActive:
          endedPolls.findIndex(({ pollId }) => pollId === poll.id) === -1,
      })),
    [createdPolls, endedPolls]
  );

  const useRaisedHandParticipants = () => {
    const raisedHandsParticipantsRef = useRef();

     const participantRaisedHand = (participantId, noOfTimesRaised) => {
      //const participantRaisedHand = (participantId) => {

      const raisedHandsParticipants = [...raisedHandsParticipantsRef.current];

      const newItem = { participantId, raisedHandOn: Date.now() , noOfTimesRaised};
     // const newItem = { participantId, raisedHandOn: new Date().getTime()};

      const participantFound = raisedHandsParticipants.findIndex(
        ({ participantId: pID }) => pID === participantId
      );

      if (participantFound === -1) {
        raisedHandsParticipants.push(newItem);
      } else {
        raisedHandsParticipants[participantFound] = newItem;
      }

      setRaisedHandsParticipants(raisedHandsParticipants);
    };

    useEffect(() => {
      raisedHandsParticipantsRef.current = raisedHandsParticipants;
    }, [raisedHandsParticipants]);


    // useEffect(() => {
    //   if (isSession == false) {
    //     window.close()
    //   }
    // }, [ isSession])

    const _handleRemoveOld = (id) => {
      const raisedHandsParticipants = [...raisedHandsParticipantsRef.current];

      const now = Date.now();

      const persisted = raisedHandsParticipants.filter(({ raisedHandOn , participantId }) => {
        //return parseInt(raisedHandOn) + 3000000 > parseInt(now);
       // return parseInt(raisedHandOn) + 10000 > parseInt(now);
        return  participantId != id
      });

      if (raisedHandsParticipants.length !== persisted.length) {
        setRaisedHandsParticipants(persisted);
      }
    };
    // useEffect(() => {
    //   const interval = setInterval(_handleRemoveOld, 500);

    //   return () => {
    //     clearInterval(interval);
    //   };
    // }, []);

    return { participantRaisedHand , _handleRemoveOld };
  };



  const calculateCurrentPollDuration = (durationInSec) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    const endTime = Date.now() + durationInSec * 1000;
    const ticktok = () => {
      const timeLeft = Math.max(Math.floor((endTime - Date.now()) / 1000), 0);
      setCurrentPollDuration(timeLeft);
      if (timeLeft > 0) {
        timerRef.current = setTimeout(ticktok, 1000);
      } else {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
    ticktok();
  };

  useEffect(()=>{
    if(sideBarMode!="CHAT"){
      // setUnreadCount(WebSocketMessages.length-chatLength);
    }
    else{
      //setUnreadCount(0);
      // setChatLength(WebSocketMessages.length);
    }
  },[sideBarMode])



  // const increaseCount = () => {
  //   if (sideBarMode !== 'CHAT') {
  //     timesChatOpened.count += 1;
  //   } else {
  //     timesChatOpened.count = 0;
  //   }
  // }
  

  return (
    <MeetingAppContext.Provider
      value={{
        // states
        raisedHandsParticipants,
        draftPolls,
        createdPolls,
        endedPolls,
        afterMeetingJoinedHLSState,
        sideBarMode,
        // setters
        setRaisedHandsParticipants,
        setMeetingRecord,
        setDraftPolls,
        setCreatedPolls,
        setEndedPolls,
        setAfterMeetingJoinedHLSState,
        setSideBarMode,
        meetingRecord,
        ws,
        WebSocketMessages,
        isWebsocketConnected,
        polls,
        useRaisedHandParticipants,
        raisedHandcountContext,
        setRaisedHandcountcontext,
        openStudentPollModal,
        setOpenStudentPollModal,
        setPollId,
        pollId,
        allPollDetails,
        setAllPollDetails,
        setCurrentPollDuration,
        currentPollDuration,
        openPollModal,
        setOpenPollModal,
        timesChatOpened,
        unReadCount,
        setNetworkStrengthOfParticipants,
        networkStrengthOfParticipants,
        openReport,
        setOpenReport,
        isClassOver,
        setIsClassOver,
        calculateCurrentPollDuration,
        whiteBoardActive,
        setWhiteBoardActive,
        whiteboardUrlStored,
        setWhiteBoardUrlStored,
        setWhiteBoardOpenedBy,
        whiteBoardOpenedBy,
        isWhiteBoardOpen,
        setIsWhiteBoardOpen,
        isFullscreenModalOpen,
        setIsFullscreenModalOpen
      }}
    >
      {children}
    </MeetingAppContext.Provider>
  );
};
